import { render, staticRenderFns } from "./step-phone.vue?vue&type=template&id=7250d5c6&"
import script from "./step-phone.js?vue&type=script&lang=js&"
export * from "./step-phone.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports